import AggregationBuilder from 'src/components/BeaconV2Components/utils/AggregationBuilder';
import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';
import { getSearchAppName } from 'src/utils/app';
import axios from 'axios';

export const fetchMetrics = async ({ retailer, mainTimePeriod, comparisonTimePeriod, skus }) => {
  if (!skus || skus.length === 0) {
    return [
      {
        aggregations: {
          by_stacklineSku: []
        }
      }
    ];
  }

  const aggregationBuilder = new AggregationBuilder('retailerId')
    .addAggregationField('Ad Clicks', 'clicks', 'sum', true)
    .addAggregationField('Ad Spend', 'spend', 'sum', true)
    .addAggregationField('Ad Sales', 'sales', 'sum', true)
    .addAggregationField(
      'Cost Per Click',
      'costPerClick',
      'computed',
      true,
      '((clicks_sum > 0) ? ((spend_sum / clicks_sum)) : (0))'
    )
    .addAggregationField(
      'ROAS',
      'returnOnAdSpend',
      'computed',
      true,
      '((spend_sum > 0) ? ((sales_sum / spend_sum)) : (0))'
    )
    .addAggregationField('Incremental Sales', 'brandTotalClicksIncrementalSales', 'sum', true)
    .addAggregationField(
      'Incrementality',
      'avgIncrementality',
      'computed',
      true,
      '((sales_sum > 0) ? ((brandTotalClicksIncrementalSales_sum / sales_sum)) : (0))'
    )
    .addComparisonRangeFilter('weekId', comparisonTimePeriod.startWeek, comparisonTimePeriod.endWeek)
    .addConditionRangeFilter('weekId', mainTimePeriod.startWeek, mainTimePeriod.endWeek)
    .addConditionTermFilter('retailerId', [retailer.id])
    .addConditionTermFilter('isProjected', ['0'], 'must')
    .setGroupByFieldName('stacklineSku');

  const builder = new AdvancedSearchRequestBuilder(
    'ineligible-entities-metrics',
    'advertising-adCampaignAdGroupProductDailyMetrics',
    {
      searchType: 'advertising-adCampaignAdGroupProductDailyMetrics' as any,
      returnDocuments: false,
      doAggregation: true,
      aggregations: [aggregationBuilder.build()],
      conditions: {
        termFilters: [],
        rangeFilters: []
      },
      pageSize: 1000
    }
  );

  builder
    .addConditionTermFilter('stacklineSku', 'should', skus)
    .addConditionTermFilter('retailerId', 'should', [retailer.id])
    .addConditionRangeFilter('weekId', mainTimePeriod.startWeek, mainTimePeriod.endWeek);

  const appName = getSearchAppName();
  const req = builder.build();
  const requestEndpoint = `api/${appName}/AdvancedSearch?_id=ineligible-products-metrics`;

  const res = await axios.post(requestEndpoint, [req]);
  return res.data;
};
